exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-link[data-v-e517099c] {\n  color: #6c757d;\n  text-decoration: none;\n}\n.btn-link[data-v-e517099c]:hover {\n  color: #21272d;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e517099c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/AdminContractsCard.vue
// module id = lScF
// module chunks = 1